"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../core/utils/index");

var ReleaseConverter_1 = require("../../release/conversions/ReleaseConverter");

var SelloutReleaseConverter_1 = require("../../release/conversions/sellout/SelloutReleaseConverter");

var Release_1 = require("../../release/model/Release");

var SelloutRelease_1 = require("../../release/model/sellout/SelloutRelease");

var PriceImpactReport_1 = require("../model/PriceImpactReport");

var ImpactConverter_1 = require("./ImpactConverter");

var PriceImpactProductReportConverter_1 = require("./PriceImpactProductReportConverter");

var PriceImpactReportConverter_1 = require("./PriceImpactReportConverter");

var PriceImpactReportConverterImpl =
/*#__PURE__*/
function (_PriceImpactReportCon) {
  _inherits(PriceImpactReportConverterImpl, _PriceImpactReportCon);

  function PriceImpactReportConverterImpl(impactConverter, productConverter, releaseConverter, selloutReleaseConverter) {
    var _this;

    _classCallCheck(this, PriceImpactReportConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceImpactReportConverterImpl).call(this));
    _this.impactConverter = impactConverter;
    _this.productConverter = productConverter;
    _this.releaseConverter = releaseConverter;
    _this.selloutReleaseConverter = selloutReleaseConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceImpactReportConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      var release;

      if (source.release) {
        release = this.getReleaseConverterByDocument(source.release).toObject(source.release, conversions);
      }

      return new PriceImpactReport_1.PriceImpactReport(PriceImpactReport_1.PriceImpactReport.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), PriceImpactReport_1.PriceImpactReport.schema.diffDays.valueOf(source.diffDays), PriceImpactReport_1.PriceImpactReport.schema.overflow.valueOf(source.overflow), conversions.asObjectOpt(source, 'salesVolumeImpact', this.impactConverter.documentToObject(conversions)), conversions.asObjectOpt(source, 'bmImpact', this.impactConverter.documentToObject(conversions)), conversions.asObjectOpt(source, 'revenueImpact', this.impactConverter.documentToObject(conversions)), conversions.asObjectOpt(source, 'profitImpact', this.impactConverter.documentToObject(conversions)), release, conversions.asObjectList(source, 'products', function (items) {
        return _this2.productConverter.toObject(items, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        diffDays: source.diffDays,
        overflow: source.overflow,
        salesVolumeImpact: index_1.Utils.isValueMissing(source.salesVolumeImpact) ? null : this.impactConverter.toDocument(source.salesVolumeImpact, conversions),
        bmImpact: index_1.Utils.isValueMissing(source.salesVolumeImpact) ? null : this.impactConverter.toDocument(source.bmImpact, conversions),
        revenueImpact: index_1.Utils.isValueMissing(source.salesVolumeImpact) ? null : this.impactConverter.toDocument(source.revenueImpact, conversions),
        profitImpact: index_1.Utils.isValueMissing(source.salesVolumeImpact) ? null : this.impactConverter.toDocument(source.profitImpact, conversions)
      };

      if (source.release) {
        result.release = this.getReleaseConverterByObject(source.release).toDocument(source.release, conversions);
      }

      if (!index_1.Utils.isValueMissing(source.products)) {
        result.products = conversions.asObjectArray(source, 'products', function (items) {
          return _this3.productConverter.toDocument(items, conversions);
        });
      }

      return result;
    }
  }, {
    key: "getReleaseConverterByObject",
    value: function getReleaseConverterByObject(release) {
      if (Release_1.Release.isRegularRelease(release)) {
        return this.releaseConverter;
      }

      if (SelloutRelease_1.SelloutRelease.isSelloutRelease(release)) {
        return this.selloutReleaseConverter;
      }

      throw new Error("Could not find converter for release type ".concat(release.releaseType));
    }
  }, {
    key: "getReleaseConverterByDocument",
    value: function getReleaseConverterByDocument(release) {
      if (release.releaseType === 'Regular') {
        return this.releaseConverter;
      }

      if (release.releaseType === 'Sellout') {
        return this.selloutReleaseConverter;
      }

      throw new Error("Could not find converter for release type ".concat(release.releaseType));
    }
  }]);

  return PriceImpactReportConverterImpl;
}(PriceImpactReportConverter_1.PriceImpactReportConverter);

PriceImpactReportConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ImpactConverter_1.ImpactConverter, PriceImpactProductReportConverter_1.PriceImpactProductReportConverter, ReleaseConverter_1.ReleaseConverter, SelloutReleaseConverter_1.SelloutReleaseConverter])], PriceImpactReportConverterImpl);
exports.PriceImpactReportConverterImpl = PriceImpactReportConverterImpl;